import style from "../style/layout.module.css";

import { Card } from "../components/";
import { Link } from "react-router-dom";
import { animated, useSpring, useChain, useSpringRef } from "@react-spring/web";

export default function Main() {
  const pRef = useSpringRef();
  const pProps = useSpring({
    ref: pRef,
    from: { opacity: 0 },
    to: { opacity: 1 },
  });
  const cardRef = useSpringRef();
  const cardsProps = useSpring({
    ref: cardRef,
    from: { opacity: 0 },
    to: { opacity: 1 },
    config: {
      duration: 500,
    },
  });
  const man = { image: "/worldcup/imgs/man/man.jpg", name: "남자" };
  const woman = { image: "/worldcup/imgs/woman/woman.jpg", name: "여자" };

  // Define the sequence of animations
  useChain([pRef, cardRef], [0, 0.25]);
  return (
    <>
      <div className="home_title">
        <animated.p style={{ ...pProps }}>당신의 성별은 무엇인가요?</animated.p>
      </div>
      <animated.div className={style.select_card} style={{ ...cardsProps }}>
        <Link to="/man" className={style.select_link}>
          <Card list={man} />
        </Link>
        <Link to="/woman" className={style.select_link}>
          <Card list={woman} />
        </Link>
      </animated.div>
    </>
  );
}
